import Alpine from 'alpinejs';
document.addEventListener("alpine:init", () => {

    Alpine.data('slayer', (mode) => ({
        mode: mode,
        slayer: {
            status: "loading",
            content: '',
            caption: '',
            size: 0,
            include_dead: false,
            five_dots: false,
            copy_both: true,
            hashtag_newlines: false,
            capitalization: "lowercase",
            selected_optimization_mode: 0,
        },
        categories: [],
        showing: "caption",
        isLoading: true,
        hasError: false,
        errorMessage: "",
        retryStatusInterval: null,
        showPostCopyModal: false,
        current_account_onboarding_counter: 0,
        
        init() {
            this.loadSlayer();

            if( this.mode == 'classic' ){
                toggleSection("hashtags");
            }
        },

        async loadSlayer() {
            this.isLoading = true;
            try {
                const response = await fetch(`/load_slayer`, {
                    method: 'GET',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) throw new Error("Failed to load slayer");

                const data = await response.json();
                this.slayer.status = data.status;
                this.slayer.content = data.content;
                this.slayer.caption = data.caption;
                this.slayer.size = data.size;
                this.slayer.include_dead = data.include_dead;
                this.slayer.five_dots = data.five_dots;
                this.slayer.copy_both = data.copy_both;
                this.slayer.hashtag_newlines = data.hashtag_newlines;
                this.slayer.capitalization = data.capitalization;
                this.slayer.selected_optimization_mode = data.selected_optimization_mode;
                this.hasError = false;

                if(this.slayer.selected_optimization_mode == null) {
                    this.slayer.selected_optimization_mode = 0;
                }

                if( data.current_account_onboarding_counter == 6 ){
                    this.toggleSection('hashtags');
                    this.current_account_onboarding_counter = data.current_account_onboarding_counter;
                }
            }
            catch (error) {
                this.hasError = true;
                this.errorMessage = error.message;
            }
            finally {
                if (this.slayer.status === "ready" || this.slayer.status === "failure") {
                    this.isLoading = false;
                    this.categories =[]; 
                } else if ( this.slayer.status === "pending" ) {
                    this.startSlayerStatusRefresh();
                }
            }
        },

        async generateHashtags() {
            this.isLoading = true;
            this.slayer.status = "pending"; 
            try {
                const payload = {
                    caption: this.slayer.caption,
                    size: this.slayer.size,
                    include_dead: this.slayer.include_dead,
                    five_dots: this.slayer.five_dots,
                    copy_both: this.slayer.copy_both,
                    hashtag_newlines: this.slayer.hashtag_newlines,
                    capitalization: this.slayer.capitalization,
                    selected_optimization_mode: this.slayer.selected_optimization_mode,
                    collections: this.categories
                }

                console.log('payload', payload);
                const response = await fetch(`/regenerate_slayer`, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) throw new Error("Failed to generate hashtags");

                const data = await response.json();
                if( data.success ) {
                    this.startSlayerStatusRefresh();
                }else{
                    this.slayer.status = "failure";
                    if (this.retryStatusInterval) {
                        clearInterval(this.retryStatusInterval);
                    }
                }
            } catch (error) {
                this.hasError = true;
                this.errorMessage = error.message;
            }
        },

        async startSlayerStatusRefresh() {
            if (this.retryStatusInterval) {
                clearInterval(this.retryStatusInterval);
            }
            this.retryStatusInterval = setInterval(() => {
                fetch(`/refresh_slayer_status`, {
                    method: "GET",
                    headers: {
                        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.status === "ready") {
                        this.loadSlayer();
                        this.toggleSection('hashtags');
                        clearInterval(this.retryStatusInterval);
                    } else {
                        this.slayer.status = data.status;
                        if ( data.status === "failure" ) {
                            clearInterval(this.retryStatusInterval);
                            this.isLoading = false;
                        }
                    }
                })
                .catch(error => {
                    console.error("Error checking status:", error);
                });
            }, 2000);
        },

        clearCaption() {
            this.slayer.caption = '';
        },

        toggleSection(section) {
            this.showing = section;
            if( section == "hashtags" ) {
                //find #content textarea and make sure that it's height matches the height of its content (but dont let it shrink below 158px)
                this.$nextTick(()=>{
                    let content = document.querySelector('#content');
                    let newHeight = Math.max(content.scrollHeight, 158);
                    content.style.height = newHeight + 'px';
                });
            } 
            if( section == "caption" ) {
                //find #content textarea and make sure that it's height matches the height of its content (but dont let it shrink below 158px)
                this.$nextTick(()=>{
                    let caption = document.querySelector('#caption');
                    let newHeight = Math.max(caption.scrollHeight, 158);
                    caption.style.height = newHeight + 'px';
                });
            } 
        },

        copyTagsToClipboard() {
            let tempTextarea = document.createElement("textarea");
            tempTextarea.style.position = "absolute";
            tempTextarea.style.left = "-1000px";
            tempTextarea.style.top = "-1000px";
            tempTextarea.value = this.slayer.content;
            document.body.appendChild(tempTextarea);
            tempTextarea.select();
            document.execCommand('copy');
            document.body.removeChild(tempTextarea);
        
            let flash = document.createElement('div');
        
            if (this.slayer.content === "") {
                flash.innerHTML = '<ul class="flash-wrapper animate flashAnimation"><li class="flash">Generate hashtags to copy.</li></ul>';
            } else {
                flash.innerHTML = '<ul class="flash-wrapper animate flashAnimation"><li class="flash">Hashtags copied. Go slay!</li></ul>';
            }
        
            if (this.current_account_onboarding_counter == 6) {
                this.showPostCopyModal = true;
                this.$nextTick(() => {
                    window.dispatchEvent(new Event('resize'));
                });
            }
        
            document.body.appendChild(flash);
        },        

        updateCategories(categoryId){
            //if in this.categories, remove it
            if( this.categories.includes(categoryId) ){
                this.categories = this.categories.filter( cat => cat != categoryId );
            }
            else{
                this.categories.push(categoryId);
            }
        }
    }));
});